export const DEACTIVATED_USER = '4012';
export const ACTIVATION_TOKEN_EXPIRED = '4003';
export const ACTIVATION_TOKEN_ACCEPTED = '4002';
export const INVALID_OLD_PASSWORD = '4005';
